import { useCallback } from 'react';
import { JWTPayload } from 'jose';

import { readTokenClaimsCached } from '../helpers/readTokenClaimsCached';
import { useTokensStore } from '../stores/useTokensStore';

export type JWTExtendedPayload = Record<string, string | number> & JWTPayload;

export const useTokenClaims = () => {
  const accessToken = useTokensStore((state) => state.accessToken);

  const readTokenClaim = useCallback(
    (claim: keyof JWTExtendedPayload) => {
      if (!accessToken) {
        return undefined;
      }

      const claims = readTokenClaimsCached(accessToken);

      return claims[claim];
    },
    [accessToken]
  );

  return readTokenClaim;
};
